(()=>{
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const root=document.documentElement;
 let observer;
 const reveal=node=>{node.classList.remove('fixx-reveal-pending');observer?.unobserve(node);};
 const finish=()=>{document.querySelectorAll('.fixx-reveal-pending').forEach(reveal);root.classList.remove('fixx-transitions-ready');observer?.disconnect();};
 const start=()=>{
  if(reduced.matches||window.Shopify?.designMode||!('IntersectionObserver' in window))return;
  observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)reveal(entry.target);}),{rootMargin:'0px 0px -24px 0px',threshold:.05});
  const main=document.getElementById('MainContent');
  if(!main)return;
  const selector=':scope > .shopify-section, .rte section, #gyf-luxe-home > section, #gyf-luxe-merch, .product__media-wrapper, .product__info-wrapper, .blog-articles > article';
  const candidates=[...main.querySelectorAll(selector)].filter(node=>{
   const box=node.getBoundingClientRect();
   return box.height>70&&box.height<innerHeight*1.8&&!node.matches('.f-reveal,.f-hero,fixx-motion')&&!node.closest('[hidden],dialog,product-form');
  });
  const nodes=candidates.filter(node=>!candidates.some(parent=>parent!==node&&parent.contains(node)));
  root.classList.add('fixx-transitions-ready');
  nodes.forEach((node,index)=>{
   if(node.getBoundingClientRect().top<innerHeight*.96)return;
   node.classList.add('fixx-reveal','fixx-reveal-pending');
   node.style.setProperty('--fixx-reveal-delay',`${index%3*35}ms`);
   observer.observe(node);
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 reduced.addEventListener('change',finish);
 document.addEventListener('focusin',event=>{const node=event.target.closest?.('.fixx-reveal-pending');if(node)reveal(node);});
 addEventListener('pageshow',event=>{if(event.persisted)finish();});
})();
